import { Button, Grid, Tooltip } from "@mui/material";

/**
 * The report's action row: Download PDF, Download Excel, Calculate and
 * Transactions.
 */
const ReportActions = ({
  isPdfLoading,
  pdfDisabled,
  pdfHint,
  onDownloadPdf,
  excelUrl,
  onDownloadExcel,
  isCalculating,
  onCalculate,
  onOpenTransactions,
}: {
  isPdfLoading: boolean;
  /** Whether the report on screen may not be exported -- downloadPdfAvailability. */
  pdfDisabled: boolean;
  /** Why it may not, shown on hover. */
  pdfHint: string;
  onDownloadPdf: () => void;
  excelUrl: string | null;
  onDownloadExcel: () => void;
  /** Whether a run against the inputs on screen is in flight. */
  isCalculating: boolean;
  onCalculate: () => void;
  onOpenTransactions: () => void;
}) => (
  <Grid container justifyContent="center" sx={{ mt: 1 }}>
    <Grid item sx={{ mr: 2 }}>
      {/* A disabled button fires no events, so the span is what the
          tooltip listens to. */}
      <Tooltip title={pdfHint}>
        <span>
          <Button
            variant="contained"
            color="primary"
            onClick={onDownloadPdf}
            disabled={isPdfLoading || pdfDisabled}
          >
            {isPdfLoading ? "Generating…" : "Download PDF"}
          </Button>
        </span>
      </Tooltip>
    </Grid>
    <Grid item sx={{ mr: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={onDownloadExcel}
        disabled={!excelUrl}
      >
        Download Excel
      </Button>
    </Grid>
    <Grid item sx={{ mr: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onCalculate()}
        disabled={isPdfLoading || isCalculating}
      >
        {isCalculating ? "Calculating…" : "Calculate"}
      </Button>
    </Grid>
    <Grid item sx={{ mr: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={onOpenTransactions}
        disabled={isPdfLoading}
      >
        {isPdfLoading ? "Updating…" : "Transactions"}
      </Button>
    </Grid>
  </Grid>
);

export default ReportActions;
